// Used in Home Page And Category Page ..
import Link from "next/link";
import { useRouter } from "next/router";
import NextImage from "./NextImage";
import { validateImgSrc } from "@/utils/global";

const CategoryCard = ({
  category: fromHome,
  fromCategory = null,
  imgPriority = "low",
}) => {
  const { locale } = useRouter();
  const category = fromCategory
    ? {
        url: fromCategory?.url_key || "",
        img:
          process.env.NEXT_PUBLIC_IMG_BASEURL +
          (fromCategory?.custom_image_responsive || "")?.replace("/media", ""),
        title: fromCategory?.name || "",
      }
    : {
        url: fromHome["category-url"],
        img: fromHome[`img-${locale}`],
        title: fromHome[`title-${locale}`],
      };

  return (
    <Link
      href={category?.url || ""}
      className="relative block overflow-hidden rounded-lg"
    >
      <NextImage
        src={
          validateImgSrc(
            (category?.img &&
              !category?.img?.endsWith("/media") &&
              category?.img) ||
              process.env.NEXT_PUBLIC_IMG_BASEURL +
                "/catalog/product/1/0/notfound.jpg"
          )
          // '/imgs/photo-category.png'
        }
        priority={imgPriority === "high" ? true : false}
        height={250}
        width={250}
        className="object-contain aspect-square h-32"
        alt={category?.title}
        title={category?.title}
      />
      <div className="absolute top-0 left-0 z-30 flex flex-col items-center justify-end p-3 text-center size-full">
        <span className=" text-sm md:text-base font-bold text-white uppercase text-balance">
          {category?.title}
        </span>
      </div>
      <span className="absolute bottom-0 left-0 z-20 w-full h-2/3 bg-gray-top rounded-b-md"></span>
    </Link>
  );
};

export default CategoryCard;
